import * as React from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import useLocale from '@/utils/locale/locale.hook'

export default function SaveMenu({ title, saveModifications, items }) {
    const [anchorEl, setAnchorEl] = React.useState(null)
    //const { height, width } = useWindowDimensions();
    const open = Boolean(anchorEl)
    const locale = useLocale()
    const handleClick = (event) => {
        if (items.length > 0) {
            setAnchorEl(event.currentTarget)
        } else saveModifications(null)
    }
    const handleClose = (hash) => {
        setAnchorEl(null)
        saveModifications(hash)
    }

    return (
        <div>
            <Button
                id="demo-positioned-button"
                aria-controls={open ? 'demo-positioned-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                disableElevation
                endIcon={items?.length > 0 ? <KeyboardArrowDownIcon /> : null}
                variant="outlined"
            >
                {title}
            </Button>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem onClick={() => handleClose(null)}>
                    <div style={{ fontSize: 14 }}>{locale?.['realTime']?.['saveZone']}</div>
                </MenuItem>
                {items?.map((el) => {
                    return (
                        <MenuItem onClick={() => handleClose(el?.hash)} key={el.name}>
                            <div style={{ fontSize: 14 }}>
                                {locale?.['realTime']?.['saveGroup']}

                                <b style={{ marginLeft: 5 }}>{el.name}</b>
                            </div>
                        </MenuItem>
                    )
                })}
            </Menu>
        </div>
    )
}
